import { render, staticRenderFns } from "./UserEditModal.vue?vue&type=template&id=7130d9ae"
import script from "./UserEditModal.vue?vue&type=script&lang=js"
export * from "./UserEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports